import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { RadioButton } from '@phosphor-icons/react'

import { cn } from '@/lib/utils'

const RadioGroup = ({ ref, className, ...props }: React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Root>) => (
  <RadioGroupPrimitive.Root className={cn(`grid gap-2`, className)} {...props} ref={ref} />
)
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = ({ ref, className, ...props }: React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Item>) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      `aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50`,
      className
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator className='relative'>
      <RadioButton className='text-current absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 fill-blue-500' weight='fill' size={18} />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
)
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
